import './AnnotationImageNameHeader.scss';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { WarningIconBadge } from '../../../components/badges/iconBadges/WarningIconBadge';

interface IProps {
  datasetName?: string;
  imageName: string;
  showWarning: boolean;
  warningTooltip: string;
  isLoading: boolean;
}

export const AnnotationImageNameHeader = observer((props: IProps): ReactElement => {
  const { imageName, datasetName, isLoading, showWarning, warningTooltip } = props;

  return (
    <div
      className='image-name-header'
      title={`${imageName}${datasetName ? ` (${datasetName})` : ''}`}
    >
      {!isLoading && (
        <>
          {imageName}{' '}
          {datasetName && (
            <span className='subtitle'>
              (
              {showWarning && (
                <WarningIconBadge
                  label=''
                  title={warningTooltip}
                />
              )}
              {datasetName})
            </span>
          )}
        </>
      )}
    </div>
  );
});
